import React from "react";
import styled from "styled-components";
import {Content, Main} from "../styles/GlobalStyles";
import Color from "../assets/Colors";
import Footer from "../components/footer/Footer";
import Header from "../components/header/Header";

export default function AuthContainer({children}) {
   return (
      <>
         <Main>
            <AuthContent className="AuthContent">
               <Header normal={true} secondary={Color.primary} primary={Color.primary} logoInvert={true} classname="invert" />
               <Content>{children}</Content>
            </AuthContent>
         </Main>
         <Footer />
      </>
   );
}

const AuthContent = styled.section`
   width: 100%;
`;
